import React from "react";
import bgfinal from "../../../img/bgfinal.jpg";
import Search from "../../Layout/Search";

const Main = () => {
  return (
    <section className='g'>
      <div className='size  ' style={style}>
        <div className=' flex h-full items-center justify-center'>
          <div className='w-full'>
            <Search></Search>
          </div>
        </div>
      </div>
    </section>
  );
};

const style = {
  background: `url(${bgfinal}) no-repeat center`,
  backgroundSize: "cover",
};

export default Main;
